import {
  acceptOnlyFilterdKeys,
  arrangeFiltersByOrder,
  basePathRewrite,
  cetgoriesCount,
  commonPropsForSSR,
  freeJobsExperiment,
  getEBendPoints,
  getEJendPoints,
  getfullUrl,
  getJobIndex,
  getSavedSearchIdData,
  getURLSearchParams,
  handeActiveFilter,
  modifyJobFilters,
  modifyQueryLocation,
  modifySelectedLocation,
  readCookie,
  titleValue,
} from '@components/common';
import { _CONSTANTS, ApplyJobStatus } from '@components/common/constant';
import {
  addJobsCountTraits,
  jobSearchResultTrackEvent,
  jobTableTrackImpressionsEvent,
} from '@components/common/event-tracker';
import {
  getFilterQueryString,
  mapQueryParams,
} from '@components/common/filterHelper';
import { jobsCategory } from '@components/common/jobCategoryHelper';
import { RemoteCategoriesMetaTags } from '@components/metaComponent/remoteCategories';
import SearchListingContainer from '@components/searchListContainer';
import { JobLinks, socialLinks } from '@components/wlb/constant';
import { JobSearchSteps, JobsList } from '@license-admin/boldjobs';
import { width } from '@styles/device.styled';
import { fireExperimentEvent } from '@utils/cdnTracking';
import jobSearchStepsProps from '@utils/jobSearchStepsProps';
import softRegModalProps from '@utils/softRegModalProps';
import useMediaQuery from '@utils/useMediaQuery';
import { applyJob, getJobDetails, logErrorServer } from 'API/ApiHelpers';
import {
  getFirstJobDetails,
  getLocalizationAndConfig,
  jobViewed,
  modifyJobDetails,
} from 'API/jobs';
import { apiCallList } from 'API/wlb/ApiClient';
import {
  getGuidValue,
  getSearchType,
  isQueryEmpty,
} from 'helper/eventTrackingUtils';
import {
  Action,
  ClickOption,
  SearchType,
  TrackingEvents,
  USER_TRAITS_JOBS_COUNT,
  ViewType,
} from 'helper/eventTrackingUtils/constant';
import { getBackendVisiterExpDetail } from 'helper/experiments/experimentActions';
import { RMCPortalExperiments } from 'helper/experiments/experimentConstants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useState } from 'react';
const ReactPaginate = dynamic(() => import('react-paginate'), { ssr: false });

const CategoryPage = (props: any) => {
  const {
    themeType,
    selectedLocation,
    searchKeyword,
    saveSearchButtonState,
    queryParams,
    jobCardData,
    localization,
    deviceType,
    config,
    isPremiumUser,
    selectedFilters,
    isLoggedIn,
    categoryDetails,
    isFromWizardPage,
    showAllDropFilters,
    userAgent,
    isSecondaryModalPopup,
  } = props;

  const router = useRouter();
  const [jobDetails, setJobDetails] = useState<any>({});
  const [isAddStaticSearchList, setAddStaticSearchList] =
    useState<boolean>(false);
  const [activeJobId, setActiveJobId] = useState<any>(null);
  const [savedJobsArray, setSavedJobsArray] = useState<number[]>([]);

  const updateSaveJobState = (jobId: number, status: boolean) => {
    if (savedJobsArray.includes(jobId) && status) {
      return;
    }
    setSavedJobsArray((prevState) =>
      !status ? prevState.filter((id) => id !== jobId) : [...prevState, jobId]
    );
  };

  const saveJobState = {
    savedJobsArray,
    updateSaveJobState,
  };

  const isMobileView =
    useMediaQuery(width.tabletSm) || props.deviceType === 'mobile';

  const queryParamsByOrder = arrangeFiltersByOrder(queryParams);

  const breadCrumbProps = {
    breadCrumbName: `${
      isPremiumUser ? 'category-rc-premium' : 'category-rc-public'
    }`,
    breadCrumbNameValue: [''],
    breadCrumbsData: [
      {
        page: 'category-rc-premium',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          {
            name: 'My Dashboard',
            path: basePathRewrite('/dashboard'),
            static: false,
          },
          {
            name: 'Remote Jobs',
            path: basePathRewrite('/remote-jobs'),
            static: false,
          },
          {
            name: `Remote ${titleValue(
              props?.pageTitle
            )} Jobs - Work From Home`,
            path: '',
            static: true,
          },
        ],
      },
      {
        page: 'category-rc-public',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          { name: 'Home', path: basePathRewrite('/'), static: false },
          {
            name: 'Remote Jobs',
            path: basePathRewrite('/remote-jobs'),
            static: false,
          },
          {
            name: `Remote ${titleValue(
              props?.pageTitle
            )} Jobs - Work From Home`,
            path: '',
            static: true,
          },
        ],
      },
    ],
  };

  useEffect(() => {
    const conductExperiment = async () => {
      const visitorId = readCookie(_CONSTANTS.VSTR);
      if (visitorId) {
        const experimentData = await getBackendVisiterExpDetail(
          deviceType,
          {
            mobile: RMCPortalExperiments.rmcLocationFieldMobile,
            desktop: RMCPortalExperiments.rmcLocationFieldDesktop,
          },
          userAgent
        );
        if (experimentData?.variant && experimentData?.variant > 2) {
          setAddStaticSearchList(true);
        }
      } else {
        setTimeout(conductExperiment, 500);
      }
    };

    const timeoutId = setTimeout(conductExperiment, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  const searchForm = (
    <SearchListingContainer
      localization={localization}
      saveSeachButtonState={saveSearchButtonState}
      showAllDropFilters={showAllDropFilters}
      deviceType={deviceType}
      categoryDetails={categoryDetails}
      isPremiumUser={isPremiumUser}
      jobsData={jobCardData}
      queryParams={queryParams}
      jobFilters={jobCardData.jobFilters}
      selectedFilters={selectedFilters}
      location={selectedLocation}
      searchedJobTitle={searchKeyword}
      isExperiment={isMobileView && isLoggedIn && !props.isPremiumUser}
      isSearchPage={false}
      isRemoteJobsPage={true}
      selectedCountry={props.selectedCountry}
      countyList={props.countryList}
      isAddStaticSearchList={isAddStaticSearchList}
      envPath={process.env.NEXT_PUBLIC_ROOT_URL}
    />
  );

  const handleApplyJob = () => {
    addJobsCountTraits(USER_TRAITS_JOBS_COUNT.JOB_APPLICATIONS);
    applyJob(activeJobId, ApplyJobStatus.applied);
    trackJobSearchResult(Action.Applied, activeJobId);
  };
  const mergedQueries = {
    ...queryParamsByOrder,
    ...router.query,
    joblocations: selectedLocation,
  };
  const jobsData = {
    ...jobCardData,
    mergedQueries: mergedQueries,
  };
  const fetchJobData = async (jobID: string) => {
    if (!jobID) throw new Error('Job ID is required for tracking.');

    const jobDetailResp = await getJobDetails(jobID);
    const jobDetails = jobDetailResp?.data;
    if (!jobDetails) throw new Error(`No job details found for ID: ${jobID}`);

    const jobIndex = getJobIndex(jobCardData.jobs.results, jobID);
    const guid = getGuidValue(props.setGuid);

    return { jobDetails, jobIndex, guid };
  };

  const determineAccessStatus = (jobDetails: any) => {
    if (isLoggedIn) {
      return isPremiumUser ? SearchType.Unlocked : SearchType.Locked;
    }
    return jobDetails?.isFreeJob ? SearchType.Unlocked : SearchType.Locked;
  };

  const trackJobSearchResult = async (
    action: string,
    jobID?: string,
    clickOption?: string
  ) => {
    const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
    const accessStatus = determineAccessStatus(jobDetails);
    const mergerdQueries = {
      ...props?.queryParams,
      ...router.query,
    };
    return jobSearchResultTrackEvent(
      action,
      getSearchType(),
      ViewType.Job_Post_Details,
      accessStatus,
      jobDetails,
      jobCardData,
      mergerdQueries,
      clickOption,
      jobIndex,
      guid
    );
  };

  const trackJobSearchImpression = async (action: string, jobID?: string) => {
    const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
    const mergerdQueries = {
      ...props?.queryParams,
      ...router.query,
    };
    return jobTableTrackImpressionsEvent(
      action,
      getSearchType(),
      TrackingEvents.Job_Search_Result,
      jobDetails,
      jobCardData,
      mergerdQueries,
      null,
      jobIndex,
      guid
    );
  };

  const showDetails = async (e: any, jobID: string) => {
    if (isMobileView) return;
    try {
      const jobDetailResp = await getJobDetails(jobID);
      if (isLoggedIn && jobID) {
        addJobsCountTraits(USER_TRAITS_JOBS_COUNT.VIEWED_JOBS);
        jobViewed(jobID);
      }
      setActiveJobId(jobID);
      setJobDetails(jobDetailResp.data);
    } catch (error) {
      // console.error('Error fetching job details:', error);
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      logErrorServer(
        `FXJ RMC_JOBS Client error: Status Code: ${errorMessage}`,
        `Failed to fetch data from Fuction: showDetails function : ${errorMessage}`,
        true
      );
    }
  };

  const hideDetails = () => {
    setActiveJobId(null);
    setJobDetails({});
  };

  const softRegProps = softRegModalProps({
    config,
    jobCardData,
    isFromWizardPage,
    isMobileView: props.deviceType === 'mobile',
    hiring_count: props.hiring_count,
    isExperiment: isMobileView && !props.isPremiumUser,
  });
  const categoryTitle = `Remote ${titleValue(
    props?.pageTitle
  )} Jobs - Work From Home`;

  const jobSearchStepsProp = jobSearchStepsProps({
    isCloseAllowed: true,
    isLoggedIn: isLoggedIn,
    themeType: themeType,
    isCategoryPage: true,
    signupAndFind: localization.unlock_banner.signup_and_find,
    jobsData: jobCardData,
    categoryDetails: categoryDetails,
    hiringCount: props.hiring_count,
    localization: localization,
    screenName: 'jobs by category',
  });
  return (
    <>
      <Head>
        {RemoteCategoriesMetaTags({
          categoryName: categoryDetails?.slug || '',
          canonicalTwo: props.useCanonicalTwo,
          isQueryParamsEmpty: props.isQueryParamsEmpty,
        })}
      </Head>
      <Script
        src="/ui-experimentation/cdn/experiment-sync.min.js"
        strategy="afterInteractive"
      />
      <Script id="experiment-script" strategy="afterInteractive">
        {`
          window.fireExperimentEvent = ${fireExperimentEvent.toString()};
        `}
      </Script>
      <JobSearchSteps jobSearchStepsProps={jobSearchStepsProp} />
      <JobsList
        isSoftRegModal={!isLoggedIn}
        softRegModalProps={softRegProps}
        breadCrumbProps={breadCrumbProps}
        showDetails={showDetails}
        hideDetails={hideDetails}
        handleApplyJob={handleApplyJob}
        jobDetails={jobDetails}
        isCategoryDetails={true}
        isSearchScreen={false}
        jobDescriptionPara={categoryDetails?.categoryOverview || ''}
        searchedJobTitle={categoryTitle}
        jobId={activeJobId}
        isPremiumUser={isPremiumUser}
        isLoggedIn={isLoggedIn}
        pageHeading={categoryTitle}
        deviceType={deviceType}
        themeType={themeType}
        categoryData={jobCardData.jobs.results}
        jobLinks={JobLinks}
        socialLinks={socialLinks}
        searchForm={searchForm}
        pageCount={jobCardData?.jobs?.totalPages} //FOR PAGINATION
        localization={localization}
        isSecondaryModalPopup={isSecondaryModalPopup}
        filterProps={{
          type: router?.query?.sortbyposteddate ? 'date' : 'relevance',
          changeFilter: (filterType: ClickOption) => {
            handeActiveFilter(filterType, router);
          },
        }}
        isNoSearchResult={jobCardData?.jobs.resultPerPage < 1}
        saveJobState={saveJobState}
        isExperiment={isMobileView && !props.isPremiumUser}
        basePathRewrite={basePathRewrite}
        trackJobSearchResult={trackJobSearchResult}
        trackJobSearchImpression={trackJobSearchImpression}
        jobCardData={jobsData}
        cetgoriesCount={cetgoriesCount}
        hiring_count={props.hiring_count}
        ReactPaginate={ReactPaginate}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  let { req, query, resolvedUrl, res } = context;
  const fullUrl = getfullUrl(req);
  // ! Last minute change to fix canonical issue for 'remote-jobs/international' page and 'remote-jobs/international' page
  const useCanonicalTwo = resolvedUrl?.includes('useCanonicalTwo');

  const category = query.category as string;
  if (!category) {
    // Check if this will ever be used
    return {
      notFound: true,
    };
  }
  let filterValues = acceptOnlyFilterdKeys(query);
  if (category.toLowerCase() !== category) {
    return {
      redirect: {
        destination: `/remote-jobs/${encodeURI(category.toLowerCase())}`,
        permanent: false,
      },
    };
  }
  let jobCardData: any = [];
  let countryList: any = [];
  let countryName = '';
  let preSelectedFilters: { [key: string]: Array<string> } = {
    categories: [category as string],
  };
  let commonSSRProps = await commonPropsForSSR(
    req,
    'new_jobs',
    preSelectedFilters
  );
  const { cookieHeader, isPremiumUser, deviceType } = commonSSRProps;
  let selectedFilters = acceptOnlyFilterdKeys(query);
  query = mapQueryParams(query);
  let queryString: string = getFilterQueryString(query);
  let selectedLocation: string = getURLSearchParams(query, 'joblocations');

  const jobsCategoryResult = await jobsCategory(
    category,
    commonSSRProps,
    filterValues,
    query,
    queryString
  );

  let categoryDetails = jobsCategoryResult?.categoryDetails || {};
  commonSSRProps = jobsCategoryResult.commonSSRProps;
  queryString = jobsCategoryResult.queryString;
  query = jobsCategoryResult.query;

  const ejEndPoints = getEJendPoints();
  const ebEndPoints = getEBendPoints();

  const apiEndpoints = {
    job_details: {
      ...ejEndPoints.job_details,
      callback: modifyJobFilters,
    },
    hiring_count: ejEndPoints.hiring_count,
    country_list: ebEndPoints.country_list,
  };

  modifyJobDetails(
    apiEndpoints.job_details,
    `search/${queryString.slice(0, -1)}`,
    { SortByPostedDate: true, jobStatus: true, cp: true },
    false
  );

  const data = await apiCallList({ apiEndpoints, cookieHeader, req });
  const {
    job_details,
    country_list,
    hiring_count = { jobsCount: 0, companiesCount: 0 },
  } = data;
  countryList = country_list;

  let result = await apiEndpoints.job_details.callback(
    query,
    job_details,
    isPremiumUser
  );

  query = result.query;
  jobCardData = result.jobCardData;

  const { locationObj, isInternationalLocation, locationNameAndState } =
    modifySelectedLocation(selectedLocation, countryList);

  if (selectedLocation) {
    selectedLocation = locationNameAndState;
    countryName = locationObj.countryName;
    query = modifyQueryLocation(locationObj, isInternationalLocation, query);
  }

  if (!categoryDetails.categoryTitle) {
    // if [category] is not category,top search or title then redirect to 404
    return {
      notFound: true,
    };
  }

  // ! This function is to get data for saved search on the basis of saved search id
  const savedSearchProps = await getSavedSearchIdData(
    req,
    query,
    cookieHeader,
    queryString,
    deviceType,
    selectedFilters
  );

  const signupLocalization = await getLocalizationAndConfig('signup');
  const firstJobData = await getFirstJobDetails(
    data?.jobs?.results[0],
    commonSSRProps.cookieHeader,
    commonSSRProps.isPremiumUser
  );

  const isQueryParamsEmpty = isQueryEmpty(resolvedUrl);

  const jobResults = await freeJobsExperiment(
    jobCardData.jobs.results,
    req.headers.cookie,
    commonSSRProps.deviceType,
    res,
    commonSSRProps.isPremiumUser
  );

  let jobsList = JSON.parse(JSON.stringify(jobCardData));
  jobsList.jobs.results = jobResults;

  return {
    props: {
      ...commonSSRProps,
      ...savedSearchProps,
      jobCardData: jobsList,
      selectedFilters: commonSSRProps.selectedFilters,
      hiring_count,
      selectedLocation,
      selectedCountry: countryName || '',
      categoryDetails: categoryDetails || {},
      countryList,
      headerProps: ['/remote-jobs', ''],
      queryParams: query,
      signupLocalization,
      ...firstJobData,
      isSecondaryModalPopup: true,
      isCategoryJobsPage: true,
      showAllDropFilters: true,
      pageTitle: categoryDetails?.categoryTitle || '',
      fullwidth: true,
      useCanonicalTwo: useCanonicalTwo || false,
      userAgent: req?.headers['user-agent'] ?? '',
      isQueryParamsEmpty: isQueryParamsEmpty,
    },
  };
};

export default CategoryPage;
